import React, { cloneElement, useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import PrimaryButton from '../../../ui/PrimaryButton';
import ActionButton, { ActionButtonItem, borderColors, splitMenuItemsIntoSections } from '../../../ui/ActionButton';
import * as XCol from "../../../framework.core/XExportColumn";
import useFunctionKeys from '../../../hooks/useFunctionKeys';
import useGlobalOkDialog from '../../../hooks/useGlobalOkDialog';
import useSystemSettings from '../../../hooks/useSystemSettings';
import BicInfoAreaHistory from '../../common/BicInfoAreaHistory';
import InfoAreaDrawer from '../../../uiControls/infoArea/InfoAreaDrawer';
import { NavigationType, openNewPage } from '../../../util/navigationHelpers';
import { billList, TableColumn, TableSettings } from '../../../tableSettings';
import constants from '../../../constants';
import ApplicationContext from '../../../ApplicationContext';
import periodCloseIcon from '../../../img/PeriodClose.svg';
import periodCloseIcon2 from '../../../img/periodclose-12.svg';
import accountCloseIcon from '../../../img/AccountClose.svg';
import accountCloseIcon2 from '../../../img/accountingclose-12.svg';
import {
  CurrencyAmountRenderer,DateRenderer,DateTimeRenderer,NullableCheckboxIconRenderer,
  TextAlignLeftRenderer,TextAlignRightRenderer,TextRenderer,
} from '../../../uiControls/SmartTableRenderers';
import JobListViewContext, { IJobListViewContext, RightClickContext } from '../../common/JobListViewContext';
import AbstractListView, {
  DataFetchResult,ExportRowRenderer,ListCustomFilterRenderer,ListOrderBy,ListRowRenderer
} from "../../common/AbstractListView";
import { Search } from '../../../filtering';
import {getJobNameByTbName, getJobNameFromInvBillCrDbJobType,getOpTypeConstant,JobNames} from '../../../framework.core/JobNames';
import { BillListItem } from '../../../fms.data/models/BillListItem';
import IfmsModal from "../../../ui/IfmsModal";
import ListViewShortcutMenu from '../../common/ListViewShortcutMenu';
import useGlobalYesNoDialog from '../../../hooks/useGlobalYesNoDialog';
import ToolboxMenuItem from '../../../uiControls/ToolboxMenuItem';
import Menu, { IfmsMenuItem } from '../../../ui/menu/Menu';
import JobListSuntekCommand from '../../common/JobListSuntekCommand';
import { BicTypeFilterRenderer, DraftFilterRenderer, PeriodRenderer, RecognizedFilterRenderer, RecognizedRenderer, StatusNotUseFileLockedRenderer, VoidFilterRenderer } from '../../common/commonListRenderers';
import { FmsSecTask } from '../../../fms.core/constants';
import fastStorage from '../../../fastStorage';
import BillInformation from '../../reports/BillInformation';
import VendorBalanceDetails from '../../reports/AccountBalance';
import { nowDate } from '../../../dateUtils';
import { SuntekSettings, SystemSettings } from '../../../ifmsTypes';
import { findSecurityTask, findSecurityTaskWithBranch, getSecBySecTask } from '../../../util';
import { useJournal } from '../general/journal/JournalListView';
import useSuntekSettings from '../../../hooks/useSuntekSettings';
import { FormType, SecType } from '../../../fms.enum';
import CopyInvoice from '../common/CopyInvoice';
import { getFmsGlobal } from '../../../globals';
import HistoryView from '../../reports/HistoryView';
import PrintBill from './report/PrintBill';
import { FmsSecCntr } from '../../../fms.core/constants/FmsSecCntr';
import CheckBoxUncontrolled from '../../../ui/CheckBoxUncontrolled';
import { CurrencyAmountValue, nullableCheckBoxValue } from '../../common/commonExportFormat';
import { BalanceIconButton, DeleteIconButton, DeleteIconButton2, EditIconButton, EditIconButton2, JournalIconButton, PrintIconButton, ViewIconButton, ViewIconButton2 } from '../../../ui/IconButton';
import HistoryIcon from '../../../img/Invoice(WH) History.svg';
import HistoryIcon2 from '../../../img/Invoice(WH) History2.svg';
import HistoryIcon_D from '../../../img/Invoice(WH) History_Dark.svg';
import HistoryIcon2_D from '../../../img/Invoice(WH) History_Dark2.svg';
import PayIcon from '../../../img/Invoice(WH) Pay.svg';
import PayIcon2 from '../../../img/Invoice(WH) Pay2.svg';
import PayIcon_D from '../../../img/Invoice(WH) Pay_Dark.svg';
import PayIcon2_D from '../../../img/Invoice(WH) Pay_Dark2.svg';
import JobSwitchingMenuContext from '../../jobSwitchingMenuContext';
import useJobMenus from '../../../hooks/useJobMenus';
import CheckBoxIcon from '../../../ui/CheckBoxIcon';
import { SearchModelBase } from '../../../fms.data/models/SearchModelBase';
import SparkleIcon from '../../../img/ai-marker.svg';

function IndicatorRenderer({ data, row }: any) {
  const jobListContext = useContext(JobListViewContext);
  const l = data[row.index];
  let dataTooltip = ''; 
  const lStatus = (l as any).status as string;
  //if (lStatus === 'PC') dataTooltip = 'Period Close';

  let content: React.ReactNode = <></>;
  if (lStatus === 'PC')
    content = <img height="12px" src={periodCloseIcon2} id={'redIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt="" />;
  else if (lStatus === 'AC')
    content = <img height="12px" src={accountCloseIcon2} id={'blackIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt="" />;

  function onIndicatorClick() {
    if (jobListContext.rowExtrasId) {
      return; // Some row is already selected
    }

    jobListContext.setRowExtrasId(data[row.index].id);
  }

  return (
    <div 
      className="ifms-table-default" 
      id={`ifms-table-default-${row.index}`}  
      data-tooltip={'Bill Information'} 
      style={{ width: '100%', minHeight: '22px', cursor: 'pointer' }}
      onClick={onIndicatorClick}>
        {content}
        </div>
    //<div className="ifms-table-default" style={{width: '100%', minHeight: '22px'}}>{content}</div>
  );
}

function DraftRenderer({ cell }: any) {
  // if (cell && cell.value) {
  //   return (
  //     <div data-tooltip={'Draft'} className="ifms-table-default">
  //       <span style={{ color: 'green' }}>V</span>
  //     </div>
  //   );
  // }

  // return <div className="ifms-table-default"></div>;

  if (cell && cell.value) {
    return <div id={`${cell.column.id}-${cell.row.index}`} className="ifms-table-default" data-tooltip={'Draft'}>
      <CheckBoxIcon value={true} />
    </div>;  
  }

  return <div className="ifms-table-default ifms-check-box-icon-false" id={`${cell.column.id}-${cell.row.index}`}></div>;
}

function BillNoRenderer({ cell }: any) {
  const rowData = cell.row.original as BillListItem;

  return (
    <div 
      id={`${cell.column.id}-${cell.row.index}`} 
      className="ifms-table-default" 
      style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%' }}
    >
      <span>{rowData.billNo}</span>
      {(rowData as any).createdBy.toUpperCase() === '@AIAGENT' && (
        <img 
          id="sparkleIcon" 
          style={{ position: 'relative', top: '0px' }} 
          src={SparkleIcon} 
          alt=""
        />
      )}
    </div>
  );
}

function ConfirmedRenderer({ value, row }: any) {
  
  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const suntekSettings = useSuntekSettings();

  if(jobListContext.opType === constants.opTypes.warehousing){
    let secCont = appContext.securityControls ? appContext.securityControls[JobNames.WHBill] : null;
    if (!secCont) {
      secCont = [
        { secCntr: FmsSecCntr.WHBillConfirmed, contName: 'chkConfirmed' }
    ];
      appContext.setSecurityControls(JobNames.WHBill, secCont);
    }
  }else{
    let secCont = appContext.securityControls ? appContext.securityControls[JobNames.Bill] : null;
      if (!secCont) {
        secCont = [
          { secCntr: FmsSecCntr.BillGivCredit, contName: 'cmdNew10' },
          { secCntr: FmsSecCntr.BillCancelCredit, contName: 'cmdNew12' },
          { secCntr: FmsSecCntr.BillConfirmed, contName: 'chkConfirmed' }
      ];
        appContext.setSecurityControls(JobNames.Bill, secCont);
      }
  }


  async function updateConfirmed(newValue: boolean) {
    await appContext.api.setBillConfirmed(row.original.id, newValue);
    row.original.confirmed = newValue;
    jobListContext.updateDataRow(row.original);
  }

  function findClickedCell(element: Element): Element | null {
    for (let i = 0; i < 6; ++i) {
      if (!element) {
        break;
      }
      if (Array.from(element.classList).some(className => className.startsWith('row-'))) {
        return element;
      }
      element = element.parentNode as Element;
    }
    return null;
  }

  return (
    <div style={{ width: '100%', textAlign: 'center' }}>
      <CheckBoxUncontrolled
        key={row.original.id}
        initialValue={Boolean(value)}
        onChange={updateConfirmed}
        disabled={appContext.getControlDisableStatus(jobListContext.opType === constants.opTypes.warehousing?JobNames.WHBill:JobNames.Bill, 'chkConfirmed', FormType.ModeEdit)}
        allowOnChange={async (e) => {
          if (!e) return false;

          e?.stopPropagation();

          const element = findClickedCell(e.currentTarget);
          if (!element) {
            await showGlobalOkDialog(<p>Cannot find hover element</p>, false, null, 'warning');
            return false;
          }

          const classes = element.classList;
          const mouseOverRowIndex = Array.from(classes).find(className => className.includes('row-'))?.match(/\d+$/)?.[0];

          if (!mouseOverRowIndex || !jobListContext.data) {
            await showGlobalOkDialog(<p>Cannot find hover data</p>, false, null, 'warning');
            return false;
          }

          const rowData = jobListContext.data[parseInt(mouseOverRowIndex)];
          if (rowData.void > 0) {
            await showGlobalOkDialog(<p>This Bill has been voided.</p>);
            return false;
          } else if (rowData.paidAmount !== 0) {
            await showGlobalOkDialog(<p>This Bill has been already paid.</p>);
            return false;
          } else if (rowData.draft) {
            await showGlobalOkDialog(<p>This Bill is Draft.</p>);
            return false;
          } else {
            return true;
          }
        }} />
    </div>
  );
}

function VoidRenderer({ cell }: any) {
  if (cell && cell.value === 1) {
    return (
      <div data-tooltip={'Void'} className="ifms-table-default">
        <span style={{ color: 'red' }}>V</span>
      </div>
    );
  }

  return <div className="ifms-table-default"></div>;
}

function formatData(data: Array<BillListItem>) {
  return data.map((d: BillListItem) => ({
    ...d,
    //status: d.draft ? '' : d.status  // draft 된 데이터에 Period Close 아이콘이 표시되지 않아 주석 처리
  }));
}

function useBillOperations() {
  const history = useHistory();
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);

  function switchToList(jobName: JobNames, jobId: number, refNo: string, hblNo: string) {
    // const blType = isMasterJob(jobName) ? 'mbl' : 'hbl';
    let blType = '';
    let columnLabel = '';
    let columnIdEx = null;
    let textEx = null;
    var opSec;
    switch (jobName) {
      case JobNames.OIMbl:
        blType = 'mbl';
        columnLabel = 'Ref. #';
        columnIdEx = 'refNo';
        textEx = refNo;
        opSec = FmsSecTask.OIMbl;
        break;
      case JobNames.OIHbl:
        blType = 'hbl';
        columnLabel = 'HBL #';
        columnIdEx = 'hblNo';
        textEx = hblNo;
        opSec = FmsSecTask.OIHbl;
        break;
      case JobNames.OEMbl:
        blType = 'oeMbl';
        columnLabel = 'Ref. #';
        columnIdEx = 'refNo';
        textEx = refNo;
        opSec = FmsSecTask.OEMbl;
        break;
      case JobNames.OEHbl:
        blType = 'oeHbl';
        columnLabel = 'HBL #';
        columnIdEx = 'hblNo';
        textEx = hblNo;
        opSec = FmsSecTask.OEHbl;
        break;
      case JobNames.AIMbl:
        blType = 'aiMawb';
        columnLabel = 'Ref. #';
        columnIdEx = 'refNo';
        textEx = refNo;
        opSec = FmsSecTask.AIMbl;
        break;
      case JobNames.AIHbl:
        blType = 'aiHawb';
        columnLabel = 'HAWB #';
        columnIdEx = 'hawbNo';
        textEx = hblNo;
        opSec = FmsSecTask.AIHbl;
        break;
      case JobNames.AEMbl:
        blType = 'aeMawb';
        columnLabel = 'Ref. #';
        columnIdEx = 'refNo';
        textEx = refNo;
        opSec = FmsSecTask.AEMbl;
        break;
      case JobNames.AEHbl:
        blType = 'aeHawb';
        columnLabel = 'HAWB #';
        columnIdEx = 'hawbNo';
        textEx = hblNo;
        opSec = FmsSecTask.AEHbl;
        break;
      case JobNames.OtherOP:
        blType = 'otherShipment';
        columnLabel = 'Ref. #';
        columnIdEx = 'refNo';
        textEx = refNo;
        opSec = FmsSecTask.OtherOP;
        break;
      case JobNames.WHRcv:
        blType = 'whReceiving';
        columnLabel = 'Receiving ID';
        columnIdEx = 'receiveNo';
        textEx = refNo;
        opSec = FmsSecTask.WHRcv;
        break;
      case JobNames.WHShip:
        blType = 'whShipping';
        columnLabel = 'Shipping ID';
        columnIdEx = 'shipNo';
        textEx = refNo;
        opSec = FmsSecTask.WHShip;
        break;
    }
    const opType = getOpTypeConstant(jobName);
    const opSecRead = findSecurityTask(appContext, opSec as FmsSecTask);
    if (opSecRead.grantRead) {
      jobListContext.setFilterForScreenExternally(`/common/joblistview/${blType}/${opType}`, 'id', columnLabel, jobId.toString(), 'u2Date', false, true, null, columnIdEx, textEx, false, true);
      openNewPage(history, `/common/joblistview/${blType}/${opType}`, NavigationType.newPage);
    }
    else {
      return;
    }
  }

  function switchToParentFor(bill: BillListItem) {
    if (!bill) {
      return;
    }

    // if (bill.type === JobNames.OIMbl) {
    //   switchToMbl(bill.parentNo ?? '');
    // }
    // if (bill.type === JobNames.OIHbl) {
    //   switchToHbl(bill.refNo ?? '');
    // }
    switchToList(getJobNameFromInvBillCrDbJobType(bill.jobType), bill.tbId, bill.refNo, bill.hblNo);

  }

  return { switchToParentFor };
}

function useSelectedBillOperations() {
  const fmsGlobal = getFmsGlobal();
  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const history = useHistory();
  const context = useContext(JobSwitchingMenuContext);
  const {removeSingleJobMenuinTab} = useJobMenus();
  const { switchToParentFor } = useBillOperations();

  const selectedElement = jobListContext.selectedElement as BillListItem;

  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();

  async function edit() {
    if (!selectedElement) {
      return;
    }

    if (!selectedElement.jobType) {
      //await showGlobalOkDialog(<p>Operation currently not implemented for this type</p>);
      return;
    }

    const id = selectedElement.id;
    const viewUrl = `/accounting/bill/view/${getJobNameFromInvBillCrDbJobType(selectedElement?.jobType)}/${selectedElement?.tbId}/${id}`;
    const editUrl = `/accounting/bill/edit/${getJobNameFromInvBillCrDbJobType(selectedElement?.jobType)}/${selectedElement?.tbId}/${id}`;

    // if (jobListContext.hasOpenedScreenInAnyOperationStartingWithUrlWithoutMe(`/accounting/bill/edit`, editUrl)) {
    //   await showGlobalOkDialog(<p>Edit operation is already in progress.</p>);
    //   return;
    // }

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(editUrl, [editUrl, viewUrl]);
  }

  async function view() {
    if (!selectedElement) {
      return;
    }

    if (!selectedElement.jobType) {
      //await showGlobalOkDialog(<p>Operation currently not implemented for this type</p>);
      return;
    }

    const id = selectedElement.id;
    const editUrl = `/accounting/bill/edit/${getJobNameFromInvBillCrDbJobType(selectedElement?.jobType)}/${selectedElement?.tbId}/${id}`;
    const viewUrl = `/accounting/bill/view/${getJobNameFromInvBillCrDbJobType(selectedElement?.jobType)}/${selectedElement?.tbId}/${id}`;

    const listSec = findSecurityTaskWithBranch(appContext, (jobListContext.opType === constants.opTypes.warehousing ? FmsSecTask.WHBill : FmsSecTask.AcctBillList), selectedElement.branch);
    const urls = [viewUrl];
    if (listSec?.grantEdit) urls.push(editUrl)

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewUrl, urls);
  }

  async function viewPaymentHistory() {
    if (!selectedElement) {
      return;
    }

    const jobId = selectedElement.id;
    const jobName = JobNames.Bill;
    const jobType = selectedElement.jobType

    const viewUrl = `/accounting/acPaymentHistoryView/${jobName}/${jobId}/${getJobNameFromInvBillCrDbJobType(jobType)}`;
    openNewPage(history, viewUrl, NavigationType.newPage);
  }

  async function deleteItem() {
    if (!selectedElement) {
      await showGlobalOkDialog('Cannot delete!',false,null,'warning');
      return;
    }
    
    // if (
    //   jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/bill/edit/${getJobNameFromInvBillCrDbJobType(selectedElement.jobType)}/${selectedElement.tbId}/${selectedElement.id}`) ||
    //   jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/bill/view/${getJobNameFromInvBillCrDbJobType(selectedElement.jobType)}/${selectedElement.tbId}/${selectedElement.id}`)
    // ) {
    //   await showGlobalOkDialog('Need to close Bill first', false, null, "warning");
    //   return;
    // }

    const doDelete = await showGlobalYesNoDialog(
      <div>
        {selectedElement.draft && <h3>Delete will remove draft data permanently.</h3>}
        <h3>Do you want to Delete?</h3>
      </div>
    ,false, 0, true, 'warning');

    if (doDelete) {
      const apiResult = await appContext.api.deleteJobDetail(JobNames.Bill, { id: selectedElement.id, opAcctBlockAfterClosed: fmsGlobal?.OPAcctBlockAfterClosed??false });
      if (apiResult && apiResult.success) {
          // List에서 데이터를 Delete할 때 해당 데이터가 View/Edit 모드로 Open 되어있으면 그 탭을 Close하도록 동작 
          const editUrl = `/accounting/bill/edit/${getJobNameFromInvBillCrDbJobType(selectedElement.jobType)}/${selectedElement.tbId}/${selectedElement.id}`;
          const viewUrl = `/accounting/bill/view/${getJobNameFromInvBillCrDbJobType(selectedElement.jobType)}/${selectedElement.tbId}/${selectedElement.id}`;
          if ( jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(editUrl) || jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(viewUrl)) {
            context.resetForCurrentJob();
            removeSingleJobMenuinTab(jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(editUrl) ? editUrl : viewUrl, '');
          }

        jobListContext.reloadData();
      } else {
        const message = apiResult?.message ?? 'Cannot delete!';
        await showGlobalOkDialog(message,false,null,'warning');
      }
    }
  }

  function switchToParent() {
    const selectedElement = jobListContext.selectedElement as BillListItem;
    switchToParentFor(selectedElement);
  }


  async function switchToPayment(){
    if (!selectedElement) {
      return;
    }
    const tbName = 'T_APHD';
    const apiResult = await appContext.api.getPaymentIds(tbName,selectedElement.id);
    if(apiResult && apiResult.result){
      const paymentDataInfos = apiResult.result;     
      let model = new SearchModelBase();
      let link = '';
      if(paymentDataInfos.length === 0){
        await showGlobalOkDialog(<p>This Bill has not been paid!</p>);
        return;
      }

      let cpayIds = paymentDataInfos.filter((item: any) => item.Type === "D").map((item: any) => item.DepoHdId).join(','); 
      let bpayIds = paymentDataInfos.filter((item: any) => item.Type === "C").map((item: any) => item.DepoHdId).join(','); 
      const cPaySec = findSecurityTask(appContext, FmsSecTask.AcctCustPayment);
      const bPaySec = findSecurityTask(appContext, FmsSecTask.AcctBillPayment);

      if(cPaySec.grantRead && cpayIds.length > 0) {
        link = '/common/joblistview/acCustomerPayment/accounting';
        model.extraWhere = `Id in (${cpayIds})`;
        jobListContext.setFilterForScreenExternally(link,'','','Payments','',false,true,model);
        openNewPage(history, link, NavigationType.newPage);
      }

      if(bPaySec.grantRead && bpayIds.length > 0) {
        link = '/common/joblistview/acBillPayment/accounting';
        model.extraWhere = `Id in (${bpayIds})`;
        jobListContext.setFilterForScreenExternally(link,'','','Payments','',false,true,model);
        openNewPage(history, link, NavigationType.newPage);
      }
    }

  }

  return { edit, view, switchToParent, deleteItem, viewPaymentHistory, switchToPayment };
}

function RightClickMenu({ dismiss }: { dismiss: VoidFunction }) {
  const { edit, view, deleteItem, switchToParent, switchToPayment } = useSelectedBillOperations();
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const selectedElement = jobListContext.selectedElement as BillListItem;

  const listSec = findSecurityTaskWithBranch(appContext, (jobListContext.opType === constants.opTypes.warehousing ? FmsSecTask.WHBill : FmsSecTask.AcctBillList), selectedElement.branch);
  // const isDraft = jobListContext.selectedElement.draft;
  const isWarehouingList = jobListContext.opType === constants.opTypes.warehousing;

  const items = [
    { label: 'View', shortcut: 'F9', separator: !listSec?.grantEdit && !listSec?.grantDel },
    { label: 'Edit', shortcut: 'F3', separator: !listSec?.grantDel, hidden: !listSec?.grantEdit },
    { label: 'Bill Information', shortcut: '', separator: false},
    { label: 'Delete', shortcut: '', separator: true, hidden: !listSec?.grantDel },
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: isWarehouingList ? 'Go to W/H List' : 'Go to BL List', shortcut: 'F6', separator: false },
    { label: 'Go to Pay List', shortcut: 'F7', separator: false },
    { label: constants.Doc_Server, shortcut: 'F8', separator: true, newCol: true },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) => ({
    label: <ToolboxMenuItem name="bill-list-sub-menu" width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    newCol: i.newCol,
    index,
    hidden: i?.hidden ?? false,
  }));

  function openBillInformation() {
    if (jobListContext.rowExtrasId) {
      return;
    }
    jobListContext.setRowExtrasId(selectedElement.id);
  }

  function onMenuItemSelected(item: IfmsMenuItem) {
    switch (item.index) {
      case 0:
        view();
        break;
      case 1:
        edit();
        break;
      case 2:
        openBillInformation();
        break;
      case 3:
        deleteItem();
        break;
      case 4:
        jobListContext.triggerTableSearch('F5');
        break;
      case 5:
        switchToParent();
        break;
      case 6:
        switchToPayment();
        break;
      case 7:
        jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
        break;
      case 8:
        jobListContext.reloadData();
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

function BillListCommands() {
  const history = useHistory();
  const jobListContext = useContext(JobListViewContext);
  const [selectedPopupMenuItem, setSelectedPopupMenuItem] = useState<ActionButtonItem | null>(null);
  const [showGlobalOkDialog] = useGlobalOkDialog();

  const selectedElement = jobListContext.selectedElement as BillListItem;

  const { edit, view, deleteItem, viewPaymentHistory } = useSelectedBillOperations();
  const {switchJournal} = useJournal();

  const appContext = useContext(ApplicationContext);
  const listSec = findSecurityTaskWithBranch(appContext, (jobListContext.opType === constants.opTypes.warehousing ? FmsSecTask.WHBill : FmsSecTask.AcctBillList), selectedElement?.branch);
  const hasSecCp = getSecBySecTask(appContext, FmsSecTask.AcctCustPayment, SecType.Add);
  const hasSecBp = getSecBySecTask(appContext, FmsSecTask.AcctBillPayment, SecType.Add);
  const hasSecBal = getSecBySecTask(appContext, FmsSecTask.ListBalance, SecType.Read);

  const hasSelectedRow = !!selectedElement;
  const userId = appContext.user?.id ?? '';
  const checkSecJournal = !getSecBySecTask(appContext, FmsSecTask.ListJournalBillings, SecType.Read)&& !userId.startsWith('@')

  const onPopupClose = () => {
    setSelectedPopupMenuItem(null);
  }

  // async function onCustomerBillAction(item: ActionButtonItem) {
  //   let link = '';
  //   switch (item.index) {
  //     case 0:
  //       link = `/accounting/acCustomerPayment/add`;
  //       break;
  //     case 1:
  //       link = `/accounting/acBillPayment/add`;
  //       break;
  //     case 2:

  //     jobListContext.setFilterForScreenExternally('/common/joblistview/acCustomerPayment/accounting', 
  //       'invoiceNo', 'Billings', selectedElement.billNo, 'updated', false, true, null);
  //       openNewPage(history, '/common/joblistview/acCustomerPayment/accounting', NavigationType.newPage);
  //       return;
  //     case 3:

  //     jobListContext.setFilterForScreenExternally('/common/joblistview/acBillPayment/accounting', 
  //       'invoiceNo', 'Billings', selectedElement.billNo, 'updated', false, true, null);
  //       openNewPage(history, '/common/joblistview/acBillPayment/accounting', NavigationType.newPage);
  //       return;
  //   }

  //   if (jobListContext.hasOpenedScreenStartingWithUrl(link)) {
  //     await showGlobalOkDialog(<p>Payment New Operation is already in progress</p>);
  //     return;
  //   }

  //   openNewPage(history, `${link}/${selectedElement.vendorId}`, NavigationType.newPage);
  // }

  // function onHistoryBtnAction(item: ActionButtonItem) {
  //   switch (item.index) {
  //     case 0:
  //       viewPaymentHistory();
  //       break;
  //     case 1:
  //       setSelectedPopupMenuItem({ label: 'View History', popupWidth: 945, popupComponent: <HistoryView jobId={selectedElement.id} jobType={selectedElement.jobType} jobName={JobNames.Bill} /> });
  //       break;
  //     // case 2:
  //     //   setSelectedPopupMenuItem({ label: 'Delete History (Bill)', popupWidth: 945, popupComponent: <HistoryView jobId={selectedElement.id} jobType={selectedElement.jobType} jobName={JobNames.Bill} viewDeleteHistory={true} /> })
  //     //   return;
  //   }
  // }

  async function vendorBalance() {
    if (selectedElement.vendorId <= 0 && (selectedElement.vendorName === null || selectedElement.vendorName === '')) {
      await showGlobalOkDialog(<p>You didn't enter Vendor.</p>,false,null,'error');
      return;
    }
    setSelectedPopupMenuItem({
      label: 'Balance',
      popupWidth: 780,
      popupComponent:
        <VendorBalanceDetails
          jobId={selectedElement.id}
          jobName={jobListContext.opType === constants.opTypes.warehousing ? JobNames.WHBill : JobNames.Bill}
          onPopupClose={onPopupClose}
          //toDate={invoice.postDate || ''}
          toDate={selectedElement.billDate??nowDate()}
          comId={selectedElement.vendorId}
          comType={'C'}
          branch={''}
          subCode={''}
          customerName={selectedElement.vendorName}
        />
    });
  }

  async function copyBill() {
    if (selectedElement.draft) {
      await showGlobalOkDialog(<p>The Draft Bill cannot be copied.</p>, false, null, 'error');
      return;
    }
    setSelectedPopupMenuItem({
      label: 'Select a target B/L to be linked',
      popupWidth: 450,
      popupComponent:
        <CopyInvoice
          jobId={selectedElement.id}
          jobName={JobNames.Bill}
          srcJobName={getJobNameFromInvBillCrDbJobType(selectedElement.jobType)}
          srcJobId={selectedElement.tbId}
          onPopupClose={onPopupClose}
        />
    });
  }


  
  const canBeEdit = hasSelectedRow && listSec?.grantEdit;
  const canBeDeleted = hasSelectedRow && listSec?.grantDel;
   const disablePrint = !hasSelectedRow; //&& selectedElement.draft;     //<240523.dwshin Invoice/Bill/CRDB - Draft인 항목을 출력 할 때, Title에 Draft 나오도록 추가>
  // const selectRowDraft = hasSelectedRow && selectedElement.draft;
  const canBeCopied = hasSelectedRow && listSec?.grantAdd;

  return (
     <div className='ifms-common-no-vertical-separator-gap-margin'>
      {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ? <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"} /> : <></>} */}
      <div className='ifms-common-vertical-gap-8'>
        <EditIconButton2 name='bill-list-edit-button' disabled={!canBeEdit} onClick={edit} useText />
        <ViewIconButton2 name='bill-list-view-button' disabled={!hasSelectedRow} onClick={view} useText/>
        <DeleteIconButton2 name='bill-list-delete-button' disabled={!canBeDeleted} onClick={deleteItem} useText />
      </div>
      {/* {jobListContext.opType === constants.opTypes.warehousing && <>
        {appContext.suntekSettings?.company?.billingsTabVersion === 2 ? <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"} /> : <></>}
        <PrintIconButton name='bill-list-print-button'
          disabled={disablePrint}
          onClick={() => setSelectedPopupMenuItem({ label: 'Print Bill', popupComponent: <PrintBill selectedElement={selectedElement} /> })} useText />
        {(hasSecCp || hasSecBp) &&
          <>
            <ActionButton
              size='extrasmall'
              useInList = {appContext.suntekSettings?.company?.billingsTabVersion !== 2}
              name='bill-list-pay-button'
              type= {appContext.suntekSettings?.company?.billingsTabVersion === 2 ? 'primary' : 'iconButton'}
              tooltip='Pay'
              items={[
                { label: 'New Customer Pay', separator: false, index: 0, hidden: !hasSecCp, name: "bill-list-sub-custpay-button" },
                { label: 'New Bill Pay', separator: true, index: 1, hidden: !hasSecBp, name: "bill-list-sub-billpay-button" },
                { label: 'Customer Pay List', separator: false, index: 2, hidden: !hasSecCp, name: "bill-list-sub-custpayList-button" },
                { label: 'Bill Pay List', separator: false, index: 3, hidden: !hasSecBp, name: "bill-list-sub-billpayList-button" },
              ]}
              onItemSelected={onCustomerBillAction}
            >
              <img src={appContext.useDarkMode ? PayIcon2_D : PayIcon2} alt="" />
            </ActionButton>
          </>
        }
        <>
          &nbsp;
          <ActionButton
            size='extrasmall'
            name='bill-list-viewhistory-button'
            type={appContext.suntekSettings?.company?.billingsTabVersion === 2 ? 'primary' : 'iconButton'}
            useInList={appContext.suntekSettings?.company?.billingsTabVersion !== 2}
            tooltip='View History'
            items={[
              { label: 'Payment History', separator: false, index: 0, hidden: !hasSelectedRow, name: "bill-list-payment-button" },
              { label: 'View History', separator: false, index: 1, hidden: !hasSelectedRow, name: "bill-list-history-button" },
            ]}
            onItemSelected={onHistoryBtnAction}
          >
            <img src={appContext.useDarkMode ? HistoryIcon2_D : HistoryIcon2} alt="" />
          </ActionButton>
        </>
      </>} */}
      <div className='ifms-common-vertical-gap-8'>
      {/* {jobListContext.opType !== constants.opTypes.warehousing && ( */}
        <>
          {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ? <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"} /> : <></>} */}
          <PrintIconButton useText
            name='billings-bill-list-print-button'
            disabled={!hasSelectedRow}
            onClick={() =>
              setSelectedPopupMenuItem({
                label: 'Print Bill',
                popupComponent: <PrintBill selectedElement={selectedElement} />,
              })
            }
          />

        </>
      {/* )} */}
      {hasSecBal && (<BalanceIconButton
        name='bill-list-vendorBalance-button'
        disabled={!hasSelectedRow}
        onClick={vendorBalance} useText />
      )}
      </div>
      <div className='ifms-common-vertical-gap-8'>
        <>
          {/* {(jobListContext.opType !== constants.opTypes.warehousing) &&  */}
            <>
              <PrimaryButton name='bill-list-copy-button' disabled={!canBeCopied} onClick={copyBill} size={'extrasmall'}>Copy/Paste</PrimaryButton>
            </>
          {/* } */}
          {/* {!!selectedPopupMenuItem && !!selectedPopupMenuItem.popupComponent ? (
            <IfmsModal isBlueHeader cancelOnEsc onCancel={onPopupClose} draggable isOpen={!!selectedPopupMenuItem} title={selectedPopupMenuItem?.popupLabel || selectedPopupMenuItem?.label} width={`${selectedPopupMenuItem?.popupWidth || 540}px`}>
              {cloneElement(selectedPopupMenuItem.popupComponent!, { onPopupClose })}
            </IfmsModal>
          ) : null} */}
        </>
      {!checkSecJournal && <JournalIconButton onClick={()=> switchJournal(JobNames.Bill, selectedElement.id, "", null, selectedElement.vendorName)} useText/> }
      </div>
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.popupComponent ? (
        <IfmsModal isBlueHeader cancelOnEsc onCancel={onPopupClose} draggable isOpen={!!selectedPopupMenuItem} title={selectedPopupMenuItem?.popupLabel || selectedPopupMenuItem?.label} width={`${selectedPopupMenuItem?.popupWidth || 540}px`}>
          {cloneElement(selectedPopupMenuItem.popupComponent!, { onPopupClose })}
        </IfmsModal>
      ) : null}
    </div>
  );
}

function TrancationImpactButtonCommands({ userId } : {userId: string}) {
  // const jobListContext = useContext(JobListViewContext);
  // const selectedElement = jobListContext.selectedElement as BillListItem;
  // const {switchJournal} = useJournal();
  // const appContext = useContext(ApplicationContext);
  
  // if ((!getSecBySecTask(appContext, FmsSecTask.ListJournalBillings, SecType.Read)&& !userId.startsWith('@'))) {
  //   return null;
  // }

  // return (
  //   <JournalIconButton onClick={()=> switchJournal(JobNames.Bill, selectedElement.id, "", null, selectedElement.vendorName)} useText/>
  // );
  return null;
}

function BillListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function BillListViewExtras({
  hideLogHistory
}: any,
) {
  useFunctionKeys({ onFunction: onFunctionKey });

  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as BillListItem;

  const listSec = findSecurityTaskWithBranch(appContext, (jobListContext.opType === constants.opTypes.warehousing ? FmsSecTask.WHBill : FmsSecTask.AcctBillList), selectedElement?.branch);
  const systemSettings = useSystemSettings();

  const { edit, view, switchToParent, switchToPayment } = useSelectedBillOperations();

  const [unprocessedFkey, setUnprocessedFkey] = useState<string | null>(null);

  useEffect(() => {
    if (!unprocessedFkey) {
      return;
    }

    doProcessFkey();
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === 'F6') {
      switchToParent();
    } else if (unprocessedFkey === "F3") {
      if(listSec?.grantEdit)
        edit();
    } else if (unprocessedFkey === "F9") {
      view();
    } else if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F8") {
      jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
    } else if (unprocessedFkey === "F7") {
      switchToPayment();
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey: string) {
    if (['F6', 'F3', 'F9', 'F11', 'F8', 'F7'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  /**
   * 
   * @param param { jobName, jobId, appContext, jobListContext } 
   * @returns 
   */
  async function loadBillHistory(param: any) {
    //const apiResult = await appContext.api.getOceanImportBillHistory(id);
    const apiResult = await appContext.api.getAcctHistory(param.jobName, param.jobId, (jobListContext.selectedElement as BillListItem).jobType, false);
    if (!apiResult || !apiResult.success) {
      return null;
    }

    return <BicInfoAreaHistory context="bill" historyData={apiResult.result} primaryCurrency={systemSettings?.primaryCurrency ?? ''} />
  }

  return (
    <InfoAreaDrawer
      showContent={jobListContext.infoAreaContent}
      jobName={JobNames.Bill}
      jobId={(jobListContext.selectedElement as BillListItem | null)?.id ?? 0}
      onClose={() => jobListContext.setInfoAreaContent('none')}
      hideLogHistory={hideLogHistory}
      parentJobId={(jobListContext.selectedElement as BillListItem | null)?.tbId??0}
      parentJobName={getJobNameByTbName((jobListContext.selectedElement as BillListItem | null)?.tbName??'')}
      
    />
  );
}

function AfterMemoLogButtonCommands() {
  // const [selectedPopupMenuItem, setSelectedPopupMenuItem] = useState<ActionButtonItem | null>(null);
  // const [showGlobalOkDialog] = useGlobalOkDialog();

  // const jobListContext = useContext(JobListViewContext);
  // const appContext = useContext(ApplicationContext);
  // const selectedElement = jobListContext.selectedElement as BillListItem;

  // const listSec = findSecurityTask(appContext, (jobListContext.opType === constants.opTypes.warehousing ? FmsSecTask.WHBill : FmsSecTask.AcctBillList));
  
  // const hasSelectedRow = !!selectedElement;
  // const canBeCopied = hasSelectedRow && listSec?.grantAdd;

  // const onPopupClose = () => {
  //   setSelectedPopupMenuItem(null);
  // }
  // async function copyBill() {
  //   if (selectedElement.draft) {
  //     await showGlobalOkDialog(<p>The Draft Bill cannot be copied.</p>, false, null, 'error');
  //     return;
  //   }
  //   setSelectedPopupMenuItem({
  //     label: 'Select a target B/L to be linked',
  //     popupWidth: 450,
  //     popupComponent:
  //       <CopyInvoice
  //         jobId={selectedElement.id}
  //         jobName={JobNames.Bill}
  //         srcJobName={getJobNameFromInvBillCrDbJobType(selectedElement.jobType)}
  //         srcJobId={selectedElement.tbId}
  //         onPopupClose={onPopupClose}
  //       />
  //   });
  // }

  // return (
  //   <>
  //     {(jobListContext.opType !== constants.opTypes.warehousing) && <>
  //       <PrimaryButton name='bill-list-copy-button' disabled={!canBeCopied} onClick={copyBill} size={'extrasmall'}>Copy/Paste</PrimaryButton>
  //     </>}
  //     {!!selectedPopupMenuItem && !!selectedPopupMenuItem.popupComponent ? (
  //       <IfmsModal isBlueHeader cancelOnEsc onCancel={onPopupClose} draggable isOpen={!!selectedPopupMenuItem} title={selectedPopupMenuItem?.popupLabel || selectedPopupMenuItem?.label} width={`${selectedPopupMenuItem?.popupWidth || 540}px`}>
  //         {cloneElement(selectedPopupMenuItem.popupComponent!, { onPopupClose })}
  //       </IfmsModal>
  //     ) : null}
  //   </>
  // )

  return null;
}

/**
 * Concrete implementation for BILL (OI) List screen
 *
 * @class BillListView
 * @extends {AbstractListView}
 */
class BillListView extends AbstractListView {
  getTableSettings(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): TableSettings {
    const useBranch = systemSettings?.enableBranch ?? false;
    const useVat = systemSettings.useVat ?? false;
    const usebillingsTabVersion1 = suntekSettings?.company?.billingsTabVersion === 1;
    let listType: JobNames.Bill | JobNames.WHBill | JobNames.GBill = JobNames.Bill;
    if (opType === constants.opTypes.warehousing) {
      listType = JobNames.WHBill;
    }

    const tsettings = billList;
    const cols = BillListItem.getExportCollection(listType, useBranch, useVat, usebillingsTabVersion1);
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type };
    });
    return tsettings;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'billDate',
      orderByAscending: false,
    };
  }

  getCustomFilterRenderers(opType?: string | undefined): ListCustomFilterRenderer[] {
    return [
      {
        accessor: 'statusNotUseFileLocked',
        renderer: StatusNotUseFileLockedRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      // {
      //   accessor: 'recognized',
      //   renderer: RecognizedFilterRenderer,
      //   searchValueExtractor: (v: any | null | undefined) => v,
      // },
      {
        accessor: 'jobType',
        renderer: (props: any) => <BicTypeFilterRenderer opType={opType} {...props} />,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      //{
      //  accessor: 'draft',
      //  renderer: DraftFilterRenderer,
      //  searchValueExtractor: (v: any | null | undefined) => v === 'D' ? true : false,
      //},
      // {
      //   accessor: 'void',
      //   renderer: VoidFilterRenderer,
      //   searchValueExtractor: (v: any | null | undefined) => v === 'V' ? 1 : 0,
      // },
      {
        accessor: 'confirmed',
        renderer: undefined,
        searchValueExtractor: (v: any | null | undefined) => v.value !== undefined ? v.value : v,
      },
    ];
  }

  getRowRenderers(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): ListRowRenderer[] {
    const useBranch = systemSettings?.enableBranch ?? false;
    const useVat = systemSettings.useVat ?? false;
    const usebillingsTabVersion1 = suntekSettings?.company?.billingsTabVersion === 1;
    let listType: JobNames.Bill | JobNames.WHBill | JobNames.GBill = JobNames.Bill;
    if (opType === constants.opTypes.warehousing) {
      listType = JobNames.WHBill;
    }

    return BillListItem.getExportCollection(listType, useBranch, useVat, usebillingsTabVersion1).map(x => {
      const colRenderer: ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if (x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      if (x.align === XCol.XAlignType.Right) colRenderer.Cell = TextAlignRightRenderer;
      if (x.dataIndex === "status") {
        colRenderer.Cell = IndicatorRenderer;
      }
      else if (x.dataIndex === "draft") {
        colRenderer.Cell = DraftRenderer;
        //colRenderer.Cell = NullableCheckboxIconRenderer;
      }
      // else if (x.dataIndex === "void") {
      //   colRenderer.Cell = VoidRenderer;
      // }
      else if (x.dataIndex === "period") {
        colRenderer.Cell = PeriodRenderer;
      }
      else if (x.dataIndex === "amount" || x.dataIndex === "paidAmount" || x.dataIndex === "balance" || x.dataIndex === "cAmount" || x.dataIndex === "dutyAmount" ||x.dataIndex ==="vatAmount") {
        colRenderer.Cell = props => <CurrencyAmountRenderer currencyAccessor={(x: any) => x.currency} {...props} />;
      } 
      // else if (x.dataIndex === 'recognized') {
      //   colRenderer.Cell = RecognizedRenderer;
      // }
      else if (x.dataIndex === "confirmed") {
        colRenderer.Cell = ConfirmedRenderer;
      }
      else if (x.dataIndex === "billNo") {       
        colRenderer.Cell = BillNoRenderer;
      }
      else if (x.dataIndex === "refNo" || x.dataIndex === "hblNo") {
        colRenderer.Cell = TextAlignLeftRenderer;
      }
      else if (x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if (x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if (x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      return colRenderer;
    });
  }
  
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({ accessor: 'status', changedValue: (value: any) => { return value['status'] === 'PC' ? 'Period Close' : '' } });
    colRenderer.push({ accessor: 'amount', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['amount']) } });
    colRenderer.push({ accessor: 'paidAmount', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['paidAmount']) } });
    colRenderer.push({ accessor: 'balance', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['balance']) } });
    colRenderer.push({ accessor: 'cAmount', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['cAmount']) } });
    colRenderer.push({ accessor: 'dutyAmount', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['dutyAmount']) } });
    colRenderer.push({ accessor: 'vatAmount', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['vatAmount']) } });
    colRenderer.push({ accessor: 'draft', changedValue: (value: any) => { return nullableCheckBoxValue(value['draft'])} });
    colRenderer.push({ accessor: 'confirmed', changedValue: (value: any) => { return nullableCheckBoxValue(value['confirmed'])} });
    return colRenderer;
  }

  async fetchAndFormatData(api: any, search: Search, pageNum: number, limit: number, opType: string | undefined): Promise<DataFetchResult> {
    BillListItem.calculateSearchParameters(search, BillListItem.MapSearchFields, ['void'],'createdBy');

    const searchModel = BillListItem.calculateSearchParameters(search, BillListItem.MapSearchFields, ['void'], 'createdBy');
    if (opType === constants.opTypes.oceanImport) searchModel.extraWhere = JobNames.OceanImport;
    else if (opType === constants.opTypes.oceanExport) searchModel.extraWhere = JobNames.OceanExport;
    else if (opType === constants.opTypes.airImport) searchModel.extraWhere = JobNames.AirImport;
    else if (opType === constants.opTypes.airExport) searchModel.extraWhere = JobNames.AirExport;
    else if (opType === constants.opTypes.otherShipment) searchModel.extraWhere = JobNames.OtherOP;

    const apiResult = await api.getListItems(opType === constants.opTypes.warehousing ? JobNames.WHBill : JobNames.Bill,
      'BillListItem',
      searchModel,
      pageNum,
      limit,
      search.pageSize,
      search.pagePerBatch
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return { data: [], totalCount: 0 };
    }

    return { data: formatData(apiResult.entities), totalCount: apiResult.totalCount };
  }

  async exportFormatDataWithExcel(api: any, search: Search, pageNum: number, limit: number, pageSize: number, pagePerBatch: number, opType: string | undefined): Promise<Array<any>> {

    const searchModel = BillListItem.calculateSearchParameters(search, BillListItem.MapSearchFields, ['void']);
    if (opType === constants.opTypes.oceanImport) searchModel.extraWhere = JobNames.OceanImport;
    else if (opType === constants.opTypes.oceanExport) searchModel.extraWhere = JobNames.OceanExport;
    else if (opType === constants.opTypes.airImport) searchModel.extraWhere = JobNames.AirImport;
    else if (opType === constants.opTypes.airExport) searchModel.extraWhere = JobNames.AirExport;
    else if (opType === constants.opTypes.otherShipment) searchModel.extraWhere = JobNames.OtherOP;

    const apiResult = await api.getListItems(opType === constants.opTypes.warehousing ? JobNames.WHBill : JobNames.Bill, 'BillListItem',
     searchModel,
      pageNum,
      limit,
      pageSize,
      pagePerBatch
      );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return [];
    }

    return formatData(apiResult.entities);
  }

  renderCommands(): React.ReactNode {
    return (
      <BillListCommands />
    );
  }

  renderBeforeConfigureButton(): React.ReactNode {
    return (
      <BillListToolbar />
    );
  }

  renderExtras(hideLogHistory: boolean): React.ReactNode {
    return (
      <BillListViewExtras hideLogHistory={hideLogHistory} />
    );
  }

  getViewUrlFor(row: BillListItem) {
    if (!row.jobType) {
      return '';  // Not supported
    }

    return { url: row && row.id ? `/accounting/bill/view/${getJobNameFromInvBillCrDbJobType(row.jobType)}/${row.tbId}/${row.id}` : '', 
      needAfterScreenUrl: true, checkAllOperation: true };
  }

  getListViewTitle() {
    return 'Bill List';
  };

  renderRowExtras(rowId: number | null, context: IJobListViewContext): React.ReactNode | null {
    if (!rowId) {
      return null;
    }

    const selectedBillNo = (context.data?.find(x => x.id === rowId) as BillListItem).billNo;

    function onPopupClose() {
      const storageKey = `bill-information-${rowId}`;
      fastStorage[storageKey] = null;
      context.setRowExtrasId(null);
    }

    return (
      <IfmsModal isBlueHeader cancelOnEsc onCancel={onPopupClose} draggable isOpen title={`Bill # : ${selectedBillNo}`} width="700px">
        <BillInformation billId={rowId} storageKey={`bill-information-${rowId}`} onPopupClose={onPopupClose} isView={false} />
      </IfmsModal>
    );
  }

  renderAdditionalCommands() {
    return <JobListSuntekCommand jobName={JobNames.Bill} keyProp='id' />;
  }

  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }
  
  useLogHistory(): boolean {
    return true;
  }

  commandsAfterFilterBtn():React.ReactNode{
    return <AfterMemoLogButtonCommands />
  }

  transactionImpactBtn(userId: string): React.ReactNode {
    return <TrancationImpactButtonCommands userId={userId} />
  }
}

export default BillListView;
